<template>
 <page>

   <head-nav :title="email.subject || ' '">
      <icon-button-back slot="left"></icon-button-back>
      <icon-button-home slot="right"></icon-button-home>
    </head-nav>

<scroll-page>

    <page-padding>
      <text-block><b>{{email.date}}</b></text-block>
      <text-block v-html="email.content"></text-block>
    <div v-for="(attachment,index) in email.attachments" :key="index">
      <div class="attachment" @click="viewPdf(attachment)">
        <ui-icon icon="file-download" backgroundColor="transparent" color="#707070"/>
        <div class="attachText">{{attachment.file}}</div>
      </div>
    </div>
    </page-padding>
 </scroll-page>
   </page>
</template>

<script>

import { mapState } from 'vuex';
import Page from '../pages/Page.vue';
import PagePadding from '../components/PagePadding.vue';
import TextBlock from '../components/TextBlock.vue';
import HeadNav from '../components/HeadNav.vue';
import IconButtonHome from '../components/buttons/IconButtonHome.vue';
import IconButtonBack from '../components/buttons/IconButtonBack.vue';
import ScrollPage from '../components/ScrollPage.vue';
//import Divider from '../components/dividers/Divider.vue';
import UiIcon from '../components/UiIcon.vue';


export default {
  name: 'view-email-item-page',
  props:{
  },
  data:function(){
    return{
      email_id:this.$route.params.id,
      email:{},
     
    }
  },
  computed:{
     ...mapState([
       'emails','appSettings','user_schools',
       ]), 
  },
  components: {
    PagePadding,
    HeadNav,
    IconButtonHome,
    IconButtonBack,
    Page,
    TextBlock,
    ScrollPage,
   // Divider,
    UiIcon,
  },
  methods:{
    viewPdf(attachment){

      //console.dir(attachment)
      // get mimetype
      var mimetype;
      switch(attachment.extension){
        case "pdf":
          mimetype="application/pdf";
        break;
        case "jpg":
          mimetype="image/jpg";
        break;
        case "png":
          mimetype="image/png";
        break;
      }

      this.$store.dispatch('open_pdf',{link:attachment.url, fileName:attachment.file, mimetype:mimetype})
      
    },
    loadEmailItem(){

      var payload={id:this.email_id}
     
      this.$store.dispatch('get_email_item',payload).then(result=>{
        this.email=result.data;
      })
    }
  },
  mounted(){
  
    // TODO: implement get_email_item fro api
    this.loadEmailItem();
 
  }
}

</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.attachment{
  display:flex;
  align-items: center;
  cursor:pointer;
  padding:10px 0;

  border-top:1px solid #D4D4D4;
}
.attachText{
  text-overflow: ellipsis;

  /* Required for text-overflow to do anything */
  white-space: nowrap;
  overflow: hidden;
}
</style>
